import dayjs from "dayjs";
import MiniInfo from "../components/Generics/MiniInfo";
import { passouDe24Horas } from "../helper";
import {
  DadosAnexosEmissaoCTe,
  DadosSolicitacaoEmissao,
} from "../model/entities/SolicitacaoEmissaoCTe";
import { ResponseGenericType } from "../model/types/ResponseType";
import api from "./api";

const ROUTE = "emissaoCTe";

class solicitacaoEmissaoCTeApi {
  async getById(id: number) {
    try {
      const res = await api.get<DadosSolicitacaoEmissao>(`/${ROUTE}/${id}`);
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async getMany(
    pagina: number,
    linhasPorPagina: number,
    campoOrdenacao: string = "id",
    direcao: "asc" | "desc" = "asc"
  ) {
    try {
      const res = await api.get(
        `/${ROUTE}?size=${linhasPorPagina}&page=${pagina}&sort=${campoOrdenacao},${direcao}`
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
  async getManySolicitacoesNaoConcluidas(
    pagina: number,
    linhasPorPagina: number
  ) {
    try {
      const res = await api.get<ResponseGenericType<DadosSolicitacaoEmissao[]>>(
        `/${ROUTE}/nao-emitidos?size=${linhasPorPagina}&page=${pagina}`
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async getManySolicitacoesConcluidas(pagina: number, linhasPorPagina: number) {
    try {
      const res = await api.get<ResponseGenericType<DadosSolicitacaoEmissao[]>>(
        `/${ROUTE}/emitidos?size=${linhasPorPagina}&page=${pagina}`
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async getAnexosSolicitacao(solicitacaoId: number) {
    try {
      const res = await api.get<DadosAnexosEmissaoCTe[]>(
        `/${ROUTE}/anexos/${solicitacaoId}`
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async uploadAnexosEmissaoCte(idSolicitacao: number, arquivos: File[]) {
    try {
      const formData = new FormData();

      if (arquivos.length > 0) {
        arquivos.forEach((arquivo) => {
          formData.append("arquivos", arquivo);
        });
      }

      const res = await api.post(
        `/${ROUTE}/uploadAnexosEmissaoCte/${idSolicitacao}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async uploadAnexosDescarregamento(
    idSolicitacao: number,
    anexosInfoDescarga: File[],
    solicitacao: DadosSolicitacaoEmissao
  ) {
    try {
      const formData = new FormData();
      if (anexosInfoDescarga.length > 0) {
        anexosInfoDescarga.forEach((anexo) => {
          formData.append("anexosInfoDescarga", anexo);
        });
      }

      const dataHora = dayjs(solicitacao.dataHoraAgendamento).format(
        "YYYY-MM-DDTHH:mm:ss"
      );

      formData.append(
        "solicitacao",
        JSON.stringify({
          ...solicitacao,
          dataHoraAgendamento: dataHora.replace("Z", ""),
        })
      );

      const res = await api.post(
        `/${ROUTE}/uploadAnexosDescarregamento/${idSolicitacao}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async count() {
    try {
      const res = await api.get<number>(`/${ROUTE}/count`);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async update(dados: DadosSolicitacaoEmissao) {
    try {
      console.log("dados", dados);
      const res = await api.put<DadosSolicitacaoEmissao>(
        `/${ROUTE}/${dados.id}`,
        dados
      );
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
  async countSolicitacoesNaoConcluidasENaoExpiradas() {
    try {
      const res = await api.get<number>(
        `/${ROUTE}/countSolicitacoesNaoConcluidasENaoExpiradas`
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
}

export const getStatusSolicitacaoCte = (
  solicitacao: DadosSolicitacaoEmissao
) => {
  const status = solicitacao.status;
  if (
    passouDe24Horas(solicitacao.dataHoraSolicitacao) &&
    status !== "EMITIDO"
  ) {
    return <MiniInfo color="#f77010 ">TEMPO EXCEDIDO</MiniInfo>;
  } else if (status === "SOLICITADO") {
    return <MiniInfo color="blue">{solicitacao.status}</MiniInfo>;
  } else if (status === "EMITIDO") {
    return <MiniInfo color="green">{solicitacao.status}</MiniInfo>;
  }
};

const apiSolicitacaoEmissaoCTeApi = new solicitacaoEmissaoCTeApi();
export default apiSolicitacaoEmissaoCTeApi;
